import './styles.css';
import { ScrollView } from '@ipfabric/ui-components/ScrollView/ScrollView';
import { Tooltip } from '@ipfabric/ui-components/Tooltip/Tooltip';
import {
  type GraphEdgeSettings,
  type PathLookupEdgeSettings,
  type PathLookupEdgeType,
  PathLookupLoopPreset,
} from '@ipfabric/utils';
import { prop } from '@ipfabric/utils/fp/prop';
import { useGraphContextSelectors } from 'components/Graph/GraphContext';
import { setPathLookupColorDetectedLoops } from 'components/Graph/commands/pathLookup/setPathLookupColorDetectedLoops';
import { PreviewDragLayer } from 'components/PreviewDragLayer/PreviewDragLayer';
import { Toggle } from 'components/Toggle/Toggle';
import { useLocale } from 'containers/App/LocaleContext';
import { memo, useState } from 'react';
import {
  DRAG_ITEM,
  PathlookupDraggableProtocol,
  type PathlookupProtocolDragItem,
} from './PathlookupDraggableProtocol';
import { PathlookupDraggableProtocolPreview } from './PathlookupDraggableProtocolPreview';

const BarePathLookupEdgeColors = () => {
  const msg = useLocale();
  const [draggedProtocol, setDraggedProtocol] =
    useState<PathLookupEdgeType | null>(null);
  const ctxProps = useGraphContextSelectors({
    dispatch: prop('dispatch'),
    edges: prop('pathlookup', 'presetDraft', 'edges'),
    colorDetectedLoops: prop(
      'pathlookup',
      'presetDraft',
      'pathLookup',
      'colorDetectedLoops',
    ),
  });

  return (
    <ScrollView className='flex-1' contentClassName='py-8'>
      <div className='mx-4 flex items-center pl-11'>
        <div
          className='w-lgu-6 h-lgu-6 mr-2.5'
          style={{ background: PathLookupLoopPreset.style.color }}
        />
        <Toggle
          label={
            msg.canvasGraph.graphSidePanel.pathlookup.highlightPacketLoops.title
          }
          labelPosition='left'
          value={ctxProps.colorDetectedLoops}
          onChange={(colorDetectedLoops) => {
            ctxProps.dispatch(setPathLookupColorDetectedLoops, {
              colorDetectedLoops,
            });
          }}
          stretch
        />
      </div>
      <div className='mx-4 my-5 border-0 border-b border-solid border-gray-600' />
      <p className='form__label mx-4'>
        {msg.canvasGraph.graphSidePanel.pathlookup.edgeColors.title}
        <Tooltip
          content={
            msg.canvasGraph.graphSidePanel.pathlookup.edgeColors.titleHelp
          }
        >
          <i className='fa fa-question-circle fa-fw ml-lgu-2' />
        </Tooltip>
      </p>
      <PreviewDragLayer<PathlookupProtocolDragItem> itemType={DRAG_ITEM}>
        {(item) => (
          <PathlookupDraggableProtocolPreview
            draggedProtocol={draggedProtocol}
            item={item}
            onProtocolIsDraggedChange={setDraggedProtocol}
          />
        )}
      </PreviewDragLayer>
      {ctxProps.edges
        .filter(
          (edge: GraphEdgeSettings): edge is PathLookupEdgeSettings =>
            edge.type === 'pathLookupEdge',
        )
        .map((edge: PathLookupEdgeSettings, index: number) => (
          <PathlookupDraggableProtocol
            color={edge.style.color}
            draggedProtocol={draggedProtocol}
            index={index}
            key={edge.id}
            name={edge.name}
            onProtocolIsDraggedChange={setDraggedProtocol}
          />
        ))}
    </ScrollView>
  );
};

export const PathLookupEdgeColors = memo(BarePathLookupEdgeColors);
